import { colors } from '../../style-guide'

export const dateTimePickerTheme = {
   light: {
      disabledArrowIconColor: colors['gray-300'],
      enableArrowIconColor: colors['gray-400'],
      triggerPlaceHolderTextColor: 'text-gray-500',
      triggerTextColor: 'text-gray-900',
      footerBorderColor: 'border-t-gray-200',
      dayPeriodValueTextColor: 'text-gray-900',
      textColor: 'text-gray-900',
      calenderIconColor: colors['gray-500'],
      closeIconColor: colors['gray-600'],
      disableTextColor: 'text-gray-500'
   },
   dark: {}
}
